import { MouseEvent, useEffect, useState } from "react"
import { scrollToAnchor } from "../../../helpers/smooth-scroll"
import { useLocation } from "react-use"
import { AccordionItem as AccordionItemProps } from "../../components/accordion/accordion-item.interface"

export const interactiveAccordion = (
  props: AccordionItemProps
): Required<AccordionItemProps> => {
  const [active, setActive] = useState(false)
  const { slug } = props
  const location = useLocation()

  const onClick = (event: MouseEvent<HTMLElement>): void => {
    setActive(!active)
    event.preventDefault()

    if (!active) {
      history.replaceState(undefined, "", `#${slug}`)
    }
  }

  useEffect(() => {
    const hash = location.hash?.substr(1)
    if (hash === slug) {
      setActive(true)
    }
    scrollToAnchor()
  }, [])

  return {
    ...props,
    active,
    onClick,
    type: props.type ?? "",
    image: props.image!,
  }
}
